import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  studioSelected: null,
}

export const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    setValue: (state, action) => {
      const payload = action.payload;
      switch (payload.type) {
        case 'studioSelected':
          state.studioSelected = payload.value;
          break;
      }
    },
  }
});

export const selectStudioSelected = (state) => state.nav.studioSelected;

export const { setValue}  = navSlice.actions;

export default navSlice.reducer;

